export default __webpack_public_path__ + "static/media/no-data-found.6eab02e4.png";